module.exports = __webpack_public_path__ + "static/media/casa-azul.61f54850.png";